<template>
  <div
    style="width: 100%"
    class="mx-0 my-0"
  >
    <v-divider class="mb-4" />
    <v-row
      class="mb-3"
      style="height: 28px"
    >
      <!--      <v-subheader>-->
      <!--        {{ $t('customFields') }}-->
      <!--      </v-subheader>-->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            small
            color="primary"
            class="mt-2"
            text
            v-on="on"
            @click="addRow"
          >
            {{ $t('addNotification') }}
            <!--            <v-icon-->
            <!--              color="teal"-->
            <!--              style="font-size: 22px"-->
            <!--            >-->
            <!--              mdi-plus-box-outline-->
            <!--            </v-icon>-->
          </v-btn>
        </template>
        <span>{{ $t('clickForAddNotification') }}</span>
      </v-tooltip>
    </v-row>
    <v-row
      v-for="(item, i) in items"
      :key="i"
      class="px-2"
    >
      <v-col
        cols="12"
        md="1"
        class="mb-0 ps-0 px-1"
      >
        <v-combobox
          v-model="item.notificationType"
          :items="typeItems"
          :rules="[v => !!v || $t('is-required')]"
          outlined
          item-value="value"
          item-text="text"
          dense
          hide-details
        >
        </v-combobox>
      </v-col>
      <v-col
        cols="12"
        md="1"
        class="mb-0 px-1"
      >
        <v-text-field
          v-model="item.value"
          height="20"
          dense
          :rules="[v => !!v || $t('is-required')]"
          outlined
          hide-details
          type="number"
          class="mb-1 dense"
          clearable
        />
      </v-col>
      <v-col
        cols="12"
        md="1"
        class="mb-0 px-1"
      >
        <v-combobox
          v-model="item.timeType"
          :items="timeTypeItems"
          :rules="[v => !!v || $t('is-required')]"
          outlined
          hide-details
          item-value="value"
          item-text="text"
          dense
        >
        </v-combobox>
      </v-col>
      <v-col
        cols="12"
        md="1"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="pink"
              icon
              small
              v-bind="attrs"
              class="ms-2 pt-1"
              v-on="on"
              @click="removeRow(item)"
            >
              <v-icon
                color="pink"
                style="font-size: 26px"
              >
                mdi-close
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('remove') }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    props: ['value', 'typeProp', 'multiple'],
    data: () => ({
      typeItems: [],
      items: [],
      model: null,
      selected: null,
      lastPage: 1,
      search: null,
      timeType: 'days',
      timeTypeItems: null,
      type: null,
      addStatus: false,
      page: 1,
    }),
    watch: {
      value (val, oldVal) {
        if (!oldVal && !this.addStatus) {
          this.setValue()
        }
        this.addStatus = false
      },
      items: {
        handler () {
          this.$emit('input', this.items)
        },
        deep: true,
      },
      search (val) {
        this.getItems()
      },
    },
    mounted () {
      this.typeItems = [
        {
          value: 'notification',
          text: this.$t('notification'),
        },
        {
          value: 'sms',
          text: this.$t('sms'),
        },
      ]
      this.timeTypeItems = [
        {
          value: 'minutes',
          text: this.$t('minutes'),
        },
        {
          value: 'hours',
          text: this.$t('hours'),
        },
        {
          value: 'days',
          text: this.$t('days'),
        },
        {
          value: 'weeks',
          text: this.$t('weeks'),
        },
      ]
      if (this.value) {
        this.setValue()
      }
    },
    methods: {
      setValue () {
        var app = this
        var row = null
        this.value.forEach((item) => {
          row = {
            notificationType: {
              value: item.type,
              text: app.$t(item.type),
            },
            timeType: {
              value: item.time_type,
              text: app.$t(item.time_type),
            },
            value: item.time_value,
          }
          app.items.push(row)
        })
      },
      addRow () {
        this.addStatus = true
        var row = {
          notificationType: {
            value: 'notification',
            text: this.$t('notification'),
          },
          timeType: {
            value: 'days',
            text: this.$t('days'),
          },
          value: 1,
        }
        this.items.push(row)
      },
      removeRow (item) {
        var i = this.items.indexOf(item)
        this.items.splice(i, 1)
      },
      visibilityChanged (e) {
      // this.page++
      // e && this.getItems()
      },
      keydown: function (event) {
      },
      submit () {
      },
      filter (item, queryText, itemText) {
        if (item.header) return false

        const hasValue = val => val != null ? val : ''

        const text = hasValue(itemText)
        const query = hasValue(queryText)

        return text.toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      },
    },
  }
</script>
